import {gsap} from 'gsap';
import {ScrollTrigger} from "gsap/ScrollTrigger.js";
import {isMobile, isTablet} from "../helpers";

export function initParallaxSection() {
    const $sections = $('.parallax-bg');
    if (!$sections.length) return;

    gsap.registerPlugin(ScrollTrigger);

    let percent = {
        plus: '30%',
        minus: '-30%'
    }
    if (isMobile() || isTablet()) {
        percent.plus = '10%';
        percent.minus = '-10%'
    }

    for (let i = 0; i < $sections.length; i++) {
        console.log(isMobile() || isTablet() ? '' : '.scroller')
        gsap.timeline({
            scrollTrigger: {
                trigger: $($sections[i]),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                invalidateOnResize: true,
            },
            // force3D: true,
            // overwrite: true,
        }).from($($sections[i]).find('img'), {
            translateY: percent.minus,
            willChange: 'transform',
        }).to($($sections[i]).find('img'), {
            translateY: percent.plus,
            willChange: 'auto'
        })
    }
}
